import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { BreederToolsScreen, BreederToolsScreenProps } from 'shared/screens/breeders/breeder-tools';
import { withServerProps } from '@web/library/with-server-props';

export default function BreederTools(props: BreederToolsScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.setTitle(t('breeder_tools.title')).setDescription(t('breeder_tools.description'))
      }
    >
      <BreederToolsScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
